<script lang="ts" setup>
import {computed} from "vue";
import {ArrowRightCircleIcon, XMarkIcon} from "@heroicons/vue/24/outline";
import {useChatSessionStore} from "@src/stores/chatSession";

const sessionStore = useChatSessionStore();

const countLabel = computed(() => {
    const total = Number(sessionStore.forwardMessagesCount ?? 0);
    return total === 1 ? '1 mensagem selecionada' : `${total} mensagens selecionadas`;
});
</script>

<template>
    <div
        class="w-full px-5 py-4 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 will-change-transform">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
                <button
                    class="w-10 h-10 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center justify-center transition cursor-pointer"
                    @click="sessionStore.stopForwardMode()"
                >
                    <XMarkIcon class="w-5 h-5 text-gray-600 dark:text-gray-300"/>
                </button>

                <div class="flex flex-col">
                    <span class="text-sm font-semibold text-gray-800 dark:text-white">
                        Encaminhar mensagem
                    </span>
                    <span class="text-xs text-gray-500 dark:text-gray-300">
                        {{ countLabel }}
                    </span>
                    <span class="text-xs text-gray-600 dark:text-gray-500">
                        Escolha até {{ sessionStore.MAX_FORWARD_TARGETS }} mensagens para encaminhar
                    </span>
                </div>
            </div>

            <button
                :disabled="sessionStore.forwardMessagesCount === 0"
                class="w-11 h-11 rounded-full bg-green-500 hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center transition cursor-pointer"
                @click="sessionStore.openForwardModal()"
            >
                <ArrowRightCircleIcon class="w-7 h-7 text-white"/>
            </button>
        </div>
    </div>
</template>